import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../../contexts/AuthContext';
import lavenderIconLight from '../../assets/blue_unfilled_icon_light.png';
import lavenderIconDark from '../../assets/lavender_unfilled_icon_dark.png';

const API_URL = '/api';

function EmailVerification() {
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { darkMode } = useContext(AuthContext);

  useEffect(() => {
    const verifyEmail = async () => {
      // Get token from URL query params
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link. No token provided.');
        return;
      }

      try {
        const response = await axios.post(`${API_URL}/verify-email`, { token });
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully! You can now log in.');

        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed. Please try again or request a new verification email.');
      }
    };

    verifyEmail();
  }, [navigate]);

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-logo">
          <h1>
            <img src={darkMode ? lavenderIconDark : lavenderIconLight} alt="Ref-Lex Icon" style={{ height: '3em', verticalAlign: 'bottom', marginRight: '0.3em' }} />
            <span className="logo-text">Ref-Lex</span>
          </h1>
          <p className="tagline">Another Reference Manager</p>
        </div>
        <h2>Email Verification</h2>

        {status === 'verifying' && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>Verifying your email address...</p>
            <div style={{ fontSize: '24px', marginTop: '10px' }}>⏳</div>
          </div>
        )}

        {status === 'success' && (
          <div className="success">
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>✓</div>
            <p>{message}</p>
            <p style={{ marginTop: '15px', fontSize: '14px', color: 'var(--text-secondary)' }}>
              Redirecting to login...
            </p>
          </div>
        )}

        {status === 'error' && (
          <div>
            <div className="error">
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>✗</div>
              <p>{message}</p>
            </div>
            <button
              onClick={() => navigate('/login')}
              style={{ marginTop: '20px', width: '100%' }}
            >
              Go to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmailVerification;
